import React from 'react';
import { Box, Image, useDeviceType } from '@packages/shared';
import { useResponsiveAkamaiTemplate } from '../../../hooks/useResponsiveAkamaiTemplate';

const thumbnailDimensionMobile = '3.75rem';
const thumbnailDimensionDesktop = '6rem';

export interface ImageGalleryThumbnailProps {
  imgSrc: string;
  alt: string;
}

export const ImageGalleryThumbnail = ({
  imgSrc,
  alt,
}: ImageGalleryThumbnailProps): React.ReactElement => {
  const deviceType = useDeviceType();
  const akamaiTemplate = useResponsiveAkamaiTemplate('thumbnail');
  const dimension = deviceType.isMobile ? thumbnailDimensionMobile : thumbnailDimensionDesktop;

  return (
    <Box
      sx={{
        width: dimension,
        height: dimension,
        position: 'relative',
        '> img': {
          maxHeight: 'auto',
          maxWidth: 'auto',
          objectFit: 'contain',
        },
      }}
    >
      <Image loading="lazy" src={`${imgSrc}?${akamaiTemplate}`} unoptimized fill alt={alt} />
    </Box>
  );
};
